import { ProductLinePartGroup } from './productlinepartgroup.model';

export class PartGroup {
    partGroupID: number;
    partGroupDesc: string;
    imageUrl: string;
    partCategoryID: number;
    isActive: boolean;
  indexOrderID: number;
  image: any;
    productLinePartGroup: ProductLinePartGroup[];
}



// WEBPACK FOOTER //
// ./src/opc/opc-app/partgroup/partgroup.model.ts